import { breakpoints } from '@src/common/breakpoints';

/** Matches viewports up to the small-tablet breakpoint (≤750px). */
export const tabletBreakpoint = `@media (max-width: ${breakpoints.smallTablet})`;

/** Card brands still sit inline at 751–768 and overflow the payment row; stack them like mobile. */
export const cardBrandsStackBreakpoint = '@media (max-width: 768px)';
